import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBuyerList } from '@/api/sys.user';
import store from '@/store/index';
export default {
  data: function data() {
    return {
      tabelData: [],
      activeName: '1',
      loading: false,
      columnConfig: {
        resizable: true
      },
      pageInfo: {
        TotalCount: null,
        size: 10,
        current: 1
      },
      VENDOR_CODE: null,
      DELIVERY_NO: null,
      keyWord: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onSearch', function (keyWord) {
      _this.keyWord = keyWord;

      _this.getTabelData();
    });
    this.getTabelData();
  },
  methods: {
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.current = index;
      this.getTabelData();
    },
    // 切换页码
    handleSizeChange: function handleSizeChange(value) {
      // console.log(value);
      this.pageInfo.size = value;
      this.getTabelData();
    },
    // 点击送货单号
    handleDELIVERY_NO: function handleDELIVERY_NO(row) {
      this.setOrderStatu('orderShow');
      var index = this.tabelData.findIndex(function (v) {
        return v.ID === row.ID;
      }); // console.log('index',index);

      this.$nextTick(function () {
        this.Bus.emit('onClickDELIVERY_NO', row, index, this.tabelData);
      });
    },
    // 获取表格数据
    getTabelData: function getTabelData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  Page: 1,
                  Limit: 10,
                  Key: null,
                  LIST_ROUTE: store.getters.routerPath,
                  TYPE_ID: '1'
                }; // console.log('params',params);

                _this2.loading = true;
                _context.next = 4;
                return getBuyerList(params);

              case 4:
                res = _context.sent;
                console.log('采购员List res', JSON.parse(JSON.stringify(res)));

                if (res.code === 0) {
                  _this2.loading = false;
                  _this2.tabelData = res.data.filter(function (item) {
                    return item.TYPE_ID === '1';
                  });
                  _this2.pageInfo.TotalCount = res.TotalCount; // console.log('this.tabelData',this.tabelData);
                } else {
                  _this2.loading = false;

                  _this2.$message.warning('获取数据失败');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};